export const applicationCityRender = (e) => {
    const city = e.data.city;
    const portfolio = e.data.isPortfolio;

    if (portfolio) {
        return 'Various';
    }

    return city;
};
